import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { environment } from 'src/environments/environment';
import { UserSettingsService } from './shared/services/user-setting.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  constructor(
    private userService: UserSettingsService,
    private title: Title,
  ) {}
  ngOnInit(): void {
    //this.userService.loadUser();
    const appTitle = (environment.appName || '').trim();
    if (appTitle) {
      this.title.setTitle(appTitle);
    }
  }
}
